<div class="component-content heightcls">
    <table class="table m-table table-bordered table-hover table-heading" style="margin-right: 19px; width: calc(100% - 19px);">
        <colgroup>
            <col style="width: 15%" />
            <col style="width: 22%" />
            <col style="width: 6%" />
            <col style="width: 15%" />
            <col style="width: 6%" />
            <col style="width: 6%" />
            <col style="width: 8%" />
            <col style="width: 10%" />
            <col style="width: 10%" />
        </colgroup>
        <thead>
            <tr>
                <th>
                    <span>Title</span>
                    <button class="btn btn-xs pull-right" (click)="sortBy('Title')" [class.btn-warning]="isSort('Title')" [class.btn-default]="!isSort('Title')">
                        <i class="fa fa-lg" [class.fa-sort-alpha-asc]="!isSortDesc('Title')" [class.fa-sort-alpha-desc]="isSortDesc('Title')"></i>
                    </button>
                </th>
                <th>
                    <span>Description</span>
                    <button class="btn btn-xs pull-right" (click)="sortBy('Description')" [class.btn-warning]="isSort('Description')" [class.btn-default]="!isSort('Description')">
                        <i class="fa fa-lg" [class.fa-sort-alpha-asc]="!isSortDesc('Description')" [class.fa-sort-alpha-desc]="isSortDesc('Description')"></i>
                    </button>
                </th>
                <th>
                    <span>Created Date</span>
                    <button class="btn btn-xs pull-right" (click)="sortBy('CreatedOn')" [class.btn-warning]="isSort('CreatedOn')" [class.btn-default]="!isSort('CreatedOn')">
                        <i class="fa fa-lg" [class.fa-sort-alpha-asc]="!isSortDesc('CreatedOn')" [class.fa-sort-alpha-desc]="isSortDesc('CreatedOn')"></i>
                    </button>
                </th>
                <th>
                    <span>Created By</span>
                    <button class="btn btn-xs pull-right" (click)="sortBy('CreatedByUsername')" [class.btn-warning]="isSort('CreatedByUsername')" [class.btn-default]="!isSort('CreatedByUsername')">
                        <i class="fa fa-lg" [class.fa-sort-alpha-asc]="!isSortDesc('CreatedByUsername')" [class.fa-sort-alpha-desc]="isSortDesc('CreatedByUsername')"></i>
                    </button>
                </th>
                <th>
                    <span>Start Date</span>
                    <button class="btn btn-xs pull-right" (click)="sortBy('StartDate')" [class.btn-warning]="isSort('StartDate')" [class.btn-default]="!isSort('StartDate')">
                        <i class="fa fa-lg" [class.fa-sort-alpha-asc]="!isSortDesc('StartDate')" [class.fa-sort-alpha-desc]="isSortDesc('StartDate')"></i>
                    </button>
                </th>
                <th>
                    <span>Expiration Date</span>
                    <button class="btn btn-xs pull-right" (click)="sortBy('ExpiresDate')" [class.btn-warning]="isSort('ExpiresDate')" [class.btn-default]="!isSort('ExpiresDate')">
                        <i class="fa fa-lg" [class.fa-sort-alpha-asc]="!isSortDesc('ExpiresDate')" [class.fa-sort-alpha-desc]="isSortDesc('ExpiresDate')"></i>
                    </button>
                </th>
                <th>
                    <span>Disabled</span>
                    <button class="btn btn-xs pull-right" (click)="sortBy('IsActive')" [class.btn-warning]="isSort('IsActive')" [class.btn-default]="!isSort('IsActive')">
                        <i class="fa fa-lg" [class.fa-sort-alpha-asc]="!isSortDesc('IsActive')" [class.fa-sort-alpha-desc]="isSortDesc('IsActive')"></i>
                    </button>
                </th>
                <th>
                    <span>Note</span>
                </th>
                <th>
                    <div class="btn-toolbar">
                        <div class="btn-group btn-group-md">
                            <a class="btn btn-primary" (click)="addNewSurvey()" title="Add Survey">
                                <i class="fa fa-fw fa-plus"></i>
                            </a>
                            <div class="btn-group btn-group-md">
                                <a class="btn" title="Filter Surveys" [class.btn-warning]="filterApplied" [class.btn-primary]="!filterApplied" (click)="openFilter()">
                                    <span data-toggle="tooltip" class="fa fa-filter fa-lg"></span>
                                </a>
                            </div>
                            <div class="btn-group btn-group-md" style="margin-left: 8px; color: #999999; text-align:center;">
                                <span style="padding-left: 2px;">Surveys</span><br />
                                {{ total }} / {{ totalDocuments }}
                            </div>
                        </div>
                    </div>
                </th>
            </tr>
        </thead>
    </table>

    <table id="survey_list_table" class="table m-table table-bordered table-hover" style="height:95%; overflow:hidden; overflow-y:scroll; display:block;">
        <colgroup>
            <col style="width: 15%" />
            <col style="width: 22%" />
            <col style="width: 6%" />
            <col style="width: 15%" />
            <col style="width: 6%" />
            <col style="width: 6%" />
            <col style="width: 8%" />
            <col style="width: 10%" />
            <col style="width: 10%" />
        </colgroup>

        <tr *ngIf="processing">
            <td colspan="8" style="align-content:center">
                <div style="text-align:center;">
                    <h3>Loading Documents...</h3>
                    <i class="fa fa-spinner fa-spin fa-pulse fa-5x"></i>
                </div>
            </td>
        </tr>

        <tr *ngFor="let surveySettings of surveySettingsList.Data" [class.activeRow]="surveySettings.IsLive">
            <td class="table-bordered" style="padding: 4px;">
                <div class="form-control-static">
                    {{ surveySettings.Title }}
                </div>
            </td>
            <td class="table-bordered" style="padding: 4px;">
                <p>{{ surveySettings.Description }}</p>
            </td>
            <td class="table-bordered" style="padding: 4px;">
                <!--  at {{ surveySettings.CreatedOn | amDateFormat: 'hh:mm A' }} -->
                <div class="form-control-static">{{ surveySettings.CreatedOn | amDateFormat: 'MM/DD/YYYY' }}</div>
            </td>
            <td class="table-bordered" style="padding: 4px; word-break: break-word;">
                <div class="form-control-static">{{ surveySettings.CreatedByUsername }}</div>
            </td>
            <td class="table-bordered" style="padding: 4px;">
                <div *ngIf="surveySettings.StartDate" class="form-control-static">{{ surveySettings.StartDate | amDateFormat: 'MM/DD/YYYY' }}</div>
            </td>
            <td class="table-bordered" style="padding: 4px;">
                <div *ngIf="surveySettings.ExpiresDate" class="form-control-static">{{ surveySettings.ExpiresDate | amDateFormat: 'MM/DD/YYYY' }}</div>
            </td>
            <td class="table-bordered" style="padding: 4px; word-break: break-word;">
                <div class="form-control-static">{{ surveySettings.IsActive ? '' : 'Disabled' }}</div>
            </td>
            <td class="table-bordered" style="padding: 4px; word-break: break-word;">
                <div *ngIf="surveySettings.IsActive && !surveySettings.IsLive" class="form-control-static">{{ surveySettings.ActiveNotes }}</div>
                <div *ngIf="surveySettings.IsLive" class="form-control-static">Live</div>
            </td>
            <td class="table-bordered" style="padding: 4px;">
                <div class="btn-group btn-group-justified" style="width: 100%;">
                    <a class="btn btn-primary btn-sm" title="Details / Edit" [class.disabled]="disable" (click)="edit(surveySettings)">
                        <i class="fa fa-list-alt fa-fw" data-toggle="tooltip"></i>
                    </a>
                    <a class="btn btn-primary btn-sm" title="Duplicate" [class.disabled]="disable" (click)="duplicate(surveySettings)">
                        <i class="fa fa-files-o fa-fw" data-toggle="tooltip"></i>
                    </a>
                    <a class="btn btn-primary btn-sm" title="Disable" [class.hidden]="!surveySettings.IsActive" (click)="disableSurvey(surveySettings)">
                        <i class="fa fa-minus-circle fa-fw" data-toggle="tooltip"></i>
                    </a>
                    <a class="btn btn-primary btn-sm" title="Enable" [class.hidden]="surveySettings.IsActive" (click)="enableSurvey(surveySettings)">
                        <i class="fa fa-plus-circle fa-fw" data-toggle="tooltip"></i>
                    </a>
                    <a class="btn btn-primary btn-sm" title="Delete" (click)="deleteSurvey(surveySettings)">
                        <i class="fa fa-trash fa-fw" data-toggle="tooltip"></i>
                    </a>
                </div>
            </td>
        </tr>

    </table>

</div>

<div bsModal #surveyEditModal="bs-modal" class="modal fade" [config]="{ keyboard: false, backdrop: 'static' }" z-index="99" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog" style="width: 90%;">
        <div class="modal-content" data-bind="with: entity">

            <div class="modal-header">
                <button type="button" class="close" aria-hidden="true" (click)="cancel()">&times;</button>
                <h4 class="modal-title" id="myModalLabel">
                    <span>{{ surveySettings.Pkid === 0 ? 'Add Survey' : 'Survey Details &bull; ' + surveySettings.Title }}</span>
                </h4>
            </div>
            <div class="modal-body" data-bind="with: $data.entity" style="padding: 8px;">
                <ul class="nav nav-tabs nav-justified">
                    <li role="presentation" [class.active]="currentView === SurveyManagementView.SurveyInformation">
                        <a role="tab" (click)="setCurrentView(SurveyManagementView.SurveyInformation)">{{SurveyManagementView.SurveyInformation}}</a>
                    </li>
                    <li role="presentation" 
                        *ngIf="surveySettings.SurveyAssignment == 2 || surveySettings.SurveyAssignment == 3" 
                        [class.active]="currentView === SurveyManagementView.Assignments">
                        <a role="tab" (click)="setCurrentView(SurveyManagementView.Assignments)">{{SurveyManagementView.Assignments}}</a>
                    </li>
                    <li role="presentation" [class.active]="currentView === SurveyManagementView.UploadPDF && dataEntryMode === DataEntryMode.Edit">
                        <a (click)="setCurrentView(SurveyManagementView.UploadPDF)" role="tab">{{SurveyManagementView.UploadPDF}}</a>
                    </li>
                    <li role="presentation" *ngIf="surveySettings.FileMetadataId && surveySettings.FileMetadataId > 0" [class.active]="currentView === SurveyManagementView.SurveyPreview">
                        <a (click)="setCurrentView(SurveyManagementView.SurveyPreview)" role="tab">{{SurveyManagementView.SurveyPreview}}</a>
                    </li>
                    <li role="presentation" *ngIf="surveySettings.Pkid > 0" [class.active]="currentView === SurveyManagementView.SurveyReport">
                        <a (click)="setCurrentView(SurveyManagementView.SurveyReport)" role="tab">{{SurveyManagementView.SurveyReport}}</a>
                    </li>
                </ul>

                <div class="tab-content">
                    <div id="fmiproductInfo" class="tab-pane tab-pane-min-size" [class.in]="currentView === SurveyManagementView.SurveyInformation" [class.active]="currentView === SurveyManagementView.SurveyInformation">
                        <form #detailForm="ngForm">
                            <div class="row">
                                <div class="col-lg-12">
                                    <span>* All fields are required</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="xor-form-group">
                                        <label class="xor-label" for="SurveyTitle">Survey Title</label>
                                        <input type="text" class="xor-form-control" rows="1" maxlength="255" id="SurveyTitle"
                                               required placeholder="Survey Title"
                                               [(ngModel)]="surveySettings.Title" name="SurveyTitle"
                                               #SurveyTitle="ngModel">
                                        <div [hidden]="(SurveyTitle.valid || SurveyTitle.pristine) && surveySettings.Title != null"
                                             class="small alert alert-danger">
                                            Survey Title must be entered.
                                        </div>
                                    </div>
                                    <div class="xor-form-group">
                                        <label class="xor-label" for="Description">Description</label>
                                        <span>: Internal Only, not displayed in Apps.</span>
                                        <textarea class="xor-form-control" rows="5" id="Description"
                                                  placeholder="Description"
                                                  [(ngModel)]="surveySettings.Description" name="Description"
                                                  #Description="ngModel"></textarea>
                                    </div>
                                    <div class="xor-form-group">
                                        <label class="xor-label" for="Message">Message</label>
                                        <span>: Notification windows will scroll to display all content.</span>
                                        <textarea class="xor-form-control" rows="5" id="Message"
                                                  placeholder="Message"
                                                  [(ngModel)]="surveySettings.Message" name="Message"
                                                  #Message="ngModel"></textarea>
                                    </div>
                                    <div class="xor-form-group">
                                        <label class="xor-label" for="lstLanguage">Language</label>
                                        <select class="xor-form-control" id="lstLanguage"
                                                required
                                                [(ngModel)]="surveySettings.Language" name="lstLanguage"
                                                #lstLanguage="ngModel">
                                            <option value="" [selected]="surveySettings.Language === null">-- Select Language --</option>
                                            <option *ngFor="let language of languages" [value]="language.Part" [selected]="surveySettings.Language == language.Part">{{ language.Part }}&nbsp;-&nbsp;{{ language.Value }}</option>
                                        </select>
                                        <div [hidden]="(lstLanguage.valid || lstLanguage.pristine) && surveySettings.Language !== &quot;&quot;"
                                             class="small alert alert-danger">
                                            Language must be selected.
                                        </div>
                                    </div>
                                    <div class="xor-form-group">
                                        <label class="xor-label" for="lstEntities">Assign To</label>
                                        <select class="xor-form-control" id="lstEntities"
                                                [(ngModel)]="surveySettings.SurveyAssignment" name="lstEntity">
                                            <option value="1" [selected]="surveySettings.SurveyAssignment == 1">All Users</option>
                                            <option value="2" [selected]="surveySettings.SurveyAssignment == 2">Companies</option>
                                            <option value="3" [selected]="surveySettings.SurveyAssignment == 3">Minesites</option>
                                        </select>
                                        <p *ngIf="surveySettingsUnaltered.SurveyAssignment == 2 && surveySettings.SurveyAssignment != surveySettingsUnaltered.SurveyAssignment"
                                           class="text-warning bg-warning" style="border: 1px solid #c09853; padding: 0 1em;">Warning: Changing assignment type will remove any assigned companies.</p>
                                        <p *ngIf="surveySettingsUnaltered.SurveyAssignment == 3 && surveySettings.SurveyAssignment != surveySettingsUnaltered.SurveyAssignment"
                                           class="text-warning bg-warning" style="border: 1px solid #c09853; padding: 0 1em;">Warning: Changing assignment type will remove any assigned minesites.</p>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="checkbox">
                                            <label class="xor-label"><input id="AllowIgnore" name="AllowIgnore" type="checkbox" [(ngModel)]="surveySettings.AllowIgnore">Allow Ignore</label>
                                        </div>
                                        <div class="checkbox">
                                            <label class="xor-label"><input id="IsActive" name="IsActive" type="checkbox" [(ngModel)]="surveySettings.IsActive">Make Active</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="xor-form-group">
                                                <label class="xor-label" for="StartDate">Start Date</label>
                                                <input id="StartDate" name="StartDate" type="date" class="form-control xor-form-control" placeholder="Start Date" [(ngModel)]="SurveyStartDate" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="xor-form-group">
                                                <label class="xor-label" for="Expiration Date">Expiration Date</label>
                                                <input id="Expiration Date" name="Expiration Date" type="date" class="form-control xor-form-control" placeholder="Expiration Date" [(ngModel)]="SurveyExpiresDate" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="xor-form-group">
                                                <label class="xor-label" for="txtFileMetadataID">Survey MetaDataId</label>
                                                <input type="text" class="form-control xor-form-control" id="txtFileMetadataId"
                                                       disabled
                                                       [(ngModel)]="surveySettings.FileMetadataId" name="txtFileMetadataId"
                                                       #txtProductName="ngModel" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="xor-form-group">
                                                <label class="xor-label" for="txtFileMetadataID">Survey Db Id</label>
                                                <input type="text" class="form-control xor-form-control" id="txtFileMetadataId"
                                                       disabled
                                                       [(ngModel)]="surveySettings.Pkid" name="txtPkid"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="xor-form-group">
                                                <label class="xor-label" for="CreatedOn">Created Date</label>
                                                <input id="CreatedOn" name="CreatedOn" type="datetime-local" class="form-control xor-form-control" placeholder="Created On" [(ngModel)]="surveySettings.CreatedOnString" disabled="disabled" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="xor-form-group">
                                                <label class="xor-label" for="CreatedByUsername">Created By</label>
                                                <input id="CreatedByUsername" name="CreatedByUsername" type="text" class="form-control xor-form-control" placeholder="CreatedByUsername" [(ngModel)]="surveySettings.CreatedByUsername" disabled="disabled" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="xor-form-group">
                                                <label class="xor-label" for="ModifiedOn">Modified Date</label>
                                                <input id="ModifiedOn" name="ModifiedOn" type="datetime-local" class="form-control xor-form-control" placeholder="Modified On" [(ngModel)]="surveySettings.ModifiedOnString" disabled="disabled" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="xor-form-group">
                                                <label class="xor-label" for="ModifiedByUsername">Modified By</label>
                                                <input id="ModifiedByUsername" name="ModifiedByUsername" type="text" class="form-control xor-form-control" placeholder="ModifiedByUsername" [(ngModel)]="surveySettings.ModifiedByUsername" disabled="disabled" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12" style="margin-top: 0px; padding: 8px 24px 8px; text-align: right;">

                                    <button type="button" class="btn btn-default" (click)="cancel()">Close</button>
                                    <button type="button" class="btn btn-success" (click)="complete()">Save</button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div id="surveyAssignments" class="tab-pane tab-pane-min-size" [class.flex-column]="currentView === SurveyManagementView.Assignments" [class.in]="currentView === SurveyManagementView.Assignments" [class.active]="currentView === SurveyManagementView.Assignments" >
                        <!-- MineSites View -->
                        <div class="row flex-row" style="flex-grow: 2; align-items: stretch" *ngIf="surveySettings.SurveyAssignment == 3">
                            <div class="col-xs-12 col-md-6 col-lg-4" style="margin-top: 10px;">
                                <div class="input-group" style="position: relative; height: 100%;">
                                    <div class="input-group-addon">
                                        <label>Company</label>
                                    </div>
                                    <select name="selectedCompaniesUserFilter" class="form-control" style="height: 100%;" size="5" multiple [(ngModel)]="selectedCompanies" (change)="getMinesitesForCompany()">
                                        <option *ngFor="let company of companies" [value]="company.Id">{{ company.Name }}</option>
                                    </select>
                                    <!-- spinner -->
                                    <div class="spinner-container-absolute" *ngIf="loadingCompanies">
                                        <i class="fa fa-circle-o-notch fa-spin fa-4x" style="color: grey;"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-md-6 col-lg-4" style="margin-top: 10px;">
                                <div class="input-group" style="position: relative; height: 100%;">
                                    <div class="input-group-addon">
                                        <label>Minesite</label>
                                    </div>
                                    <select name="selectedMinesitesUserFilter" class="form-control" style="height: 100%;" size="5" [(ngModel)]="selectedMinesites" (change)="addSelectedMineSiteToAssignments()">
                                        <option *ngFor="let minesite of filteredMinesites" [value]="minesite.Id">{{ minesite.Name }}</option>
                                    </select>
                                    <!-- spinner -->
                                    <div class="spinner-container-absolute" *ngIf="loadingMinesites">
                                        <i class="fa fa-circle-o-notch fa-spin fa-4x" style="color: grey;"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-md-6 col-lg-4" style="margin-top: 10px;">
                                <div class="input-group" style="position: relative; height: 100%;">
                                    <div class="input-group-addon" style="position:relative;">
                                        <label>Selected Minesites</label>
                                        <label *ngIf="finalMinesites?.length > 0" style="display: block; position: absolute;bottom: 1em; left: .5em; right: .5em; font-weight: normal; white-space: break-spaces; line-height: 1.25em;">(double click to remove individual selections)</label>
                                    </div>
                                    <select name="finalMinesitesUserFilter" class="form-control" style="height: 100%;" size="5" multiple [(ngModel)]="selectedMinesitesForRemoval">
                                        <option *ngFor="let minesite of finalMinesites" [value]="minesite.Id" (dblclick)="removeFromMineSiteAssignments()">{{ minesite.Name }}</option>
                                    </select>
                                    <!-- spinner -->
                                    <div class="spinner-container-absolute" *ngIf="loadingMinesiteAssignments">
                                        <i class="fa fa-circle-o-notch fa-spin fa-4x" style="color: grey;"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Companay View -->
                        <div class="row flex-row" style="flex-grow: 2; align-items: stretch" *ngIf="surveySettings.SurveyAssignment == 2">
                            <div class="col-md-6" style="margin-top: 10px;">
                                <div class="input-group" style="position: relative; height: 100%;">
                                    <div class="input-group-addon">
                                        <label>Company</label>
                                    </div>
                                    <select name="selectCompaniesUserFilter" class="form-control" style="height: 100%;" size="5" [(ngModel)]="selectedCompany" (change)="addSelectedCompanyToAssignments()">
                                        <option *ngFor="let company of companies" [value]="company.Id">{{ company.Name }}</option>
                                    </select>
                                    <!-- spinner -->
                                    <div class="spinner-container-absolute" *ngIf="loadingCompanies">
                                        <i class="fa fa-circle-o-notch fa-spin fa-4x" style="color: grey;"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6" style="margin-top: 10px;">
                                <div class="input-group" style="position: relative; height: 100%;">
                                    <div class="input-group-addon" style="position:relative;">
                                        <label>Selected Companies</label>
                                        <label *ngIf="finalCompanies?.length > 0" style="display: block; position: absolute;bottom: 1em; left: .5em; right: .5em; font-weight: normal; white-space: break-spaces; line-height: 1.25em;">(double click to remove individual selections)</label>
                                    </div>
                                    <select name="finalCompaniesUserFilter" class="form-control" style="height: 100%;" size="5" multiple [(ngModel)]="selectedCompanyForRemoval">
                                        <option *ngFor="let company of finalCompanies" [value]="company.Id" (dblclick)="removeFromCompanyAssignments()">{{ company.Name }}</option>
                                    </select>
                                    <!-- spinner -->
                                    <div class="spinner-container-absolute" *ngIf="loadingCompanyAssignments">
                                        <i class="fa fa-circle-o-notch fa-spin fa-4x" style="color: grey;"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row"  style="flex-grow: 0;">
                            <div class="col-md-12">
                                <hr />
                            </div>
                        </div>
                        <div class="row"  style="flex-grow: 0;" *ngIf="surveySettings.SurveyAssignment == 3">
                            <div class="col-md-6">
                                <button type="button" class="btn btn-success" *ngIf="companyfilterApplied" (click)="clearCompanyFilter()">Clear Company Selection</button>
                                <button type="button" class="btn btn-success" *ngIf="finalMinesites.length > 0" (click)="clearMinesiteFilter()">Clear Minesite Selection</button>
                            </div>
                        </div>
                        <div class="row"  style="flex-grow: 0;" *ngIf="surveySettings.SurveyAssignment == 2">
                            <div class="col-md-6">
                                <button type="button" class="btn btn-success" *ngIf="finalCompanies.length > 0" (click)="finalCompanies = [];selectedCompany = -1">Clear Company Selection</button>
                            </div>
                        </div>
                        <div class="row"  style="flex-grow: 0;">
                            <div class="col-lg-12" style="margin-top: 0px; vertical-align: bottom; padding: 8px 24px 8px; text-align: right;">
                                <button type="button" class="btn btn-default" (click)="cancel()">Close</button>
                                <button type="submit" class="btn btn-success" (click)="complete()">Save</button>
                            </div>
                        </div>
                    </div>
                    <div id="pdfUpload" class="tab-pane tab-pane-min-size" [class.in]="currentView === SurveyManagementView.UploadPDF" [class.active]="currentView === SurveyManagementView.UploadPDF">
                        <div class="row" style="margin-top: 50px;">
                            <div class="col-lg-12">
                                <span>Upload a survey document. Once uploaded you will be able to preview/verify it in another tab.</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-6">
                                <form (ngSubmit)="UploadFile()" #pdfForm="ngForm">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="xor-form-group">
                                                <label class="xor-label" for="pdfFileInput">Choose a file:</label>
                                                <input id="pdfFileInput" type="file" accept="application/pdf" style="width: 75%;" (change)="pdfFileChange()" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-12">
                                            <button type="submit" class="btn btn-warning btn-sm" [disabled]="!pdfForm.form.valid">Upload File</button>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6" *ngIf="processingAzurePDF">
                                            <div style="width:100%; text-align:center;">
                                                <span>Uploading to ProManual ...</span>
                                                <i class="fa fa-spinner fa-spin fa-pulse fa-2x"></i>
                                            </div>
                                        </div>
                                        <div id="divUploadAzurePDFCompleted" class="col-sm-6" *ngIf="uploadAzurePDFCompleted">
                                            <div style="width:100%; text-align:center;">
                                                <span style="color:darkred">Document successfully uploaded to ProManual.</span>
                                                <br />
                                                <span style="color:darkred">Click on Browse/Choose File to upload another.</span>
                                            </div>
                                        </div>
                                        <div id="divUploadAzurePDFError" class="col-sm-6" *ngIf="uploadAzurePDFError">
                                            <div style="width:100%; text-align:center;">
                                                <span style="color:darkred">ERROR uploading to ProManual</span>
                                                <br />
                                                <span style="color:darkred">{{ errMsgAzurePDF }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="col-lg-6">
                                &nbsp;
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <span>Version History</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <table class="table m-table table-bordered table-hover table-heading">
                                    <colgroup>
                                        <col style="width:75px;" />
                                        <col style="width:400px;" />
                                        <col style="width:100px;" />
                                        <col style="width:100px;" />
                                        <col style="width:auto;" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>
                                                <span style="line-height: 1.42857143; font-weight:bold; vertical-align:middle; text-align:center;">Id</span>
                                            </th>
                                            <th>
                                                <span style="line-height: 1.42857143; font-weight:bold; vertical-align:middle; text-align:center;">File Name</span>
                                            </th>
                                            <th>
                                                <span style="line-height: 1.42857143; font-weight:bold; vertical-align:middle; text-align:center;">Upload Date</span>
                                            </th>
                                            <th>
                                                <span style="line-height: 1.42857143; font-weight:bold; vertical-align:middle; text-align:center;">Metadata Id</span>
                                            </th>
                                            <th>
                                                <span style="line-height: 1.42857143; font-weight:bold; vertical-align:middle; text-align:center;">Replace By Id</span>
                                            </th>
                                        </tr>
                                    </thead>
                                </table>
                                <div style="height:300px; overflow-y:scroll; margin-top:-20px;">
                                    <table class="table m-table table-bordered table-hover table-heading" style="margin-bottom:0px;">
                                        <colgroup>
                                            <col style="width:75px;" />
                                            <col style="width:400px;" />
                                            <col style="width:100px;" />
                                            <col style="width:100px;" />
                                            <col style="width:auto;" />
                                        </colgroup>
                                        <tbody>
                                            <tr *ngFor="let document of historyDocuments">
                                                <td>
                                                    <span>{{ document.Pkid }}</span>
                                                </td>
                                                <td>
                                                    <span>{{ document.FileName }}</span>
                                                </td>
                                                <td>
                                                    <span>{{ document.UploadDate | amDateFormat: 'MM/DD/YYYY' }}</span>
                                                </td>
                                                <td>
                                                    <span>{{ document.MetadataId }}</span>
                                                </td>
                                                <td>
                                                    <span>{{ document.ReplacedById }}</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12" style="padding: 8px 24px 8px; vertical-align: bottom; text-align: right;">
                                <button type="button" class="btn btn-default" (click)="cancel()">Close</button>
                            </div>
                        </div>
                    </div>
                    <div id="surveyPreviewPane" class="tab-pane tab-pane-min-size" [class.in]="currentView === SurveyManagementView.SurveyPreview" [class.active]="currentView === SurveyManagementView.SurveyPreview">
                        <div class="row" style="min-height: 200px; position: relative;">
                            <div *ngIf="pdfSrc && !downloadingDocument" class="col-lg-12">
                                <pdf-viewer [src]="pdfSrc"
                                            [render-text]="true"
                                            [show-all]="true"
                                            [autoresize]="true"
                                            (after-load-complete)="onLoadPDF($event)"
                                            (error)="onPDFLoadError($event)"
                                            (on-progress)="onPDFLoadProgress($event)"
                                            style="display: block; min-height: 80vh; width: 100%; background-color: grey; border: 1px solid grey;"></pdf-viewer>
                            </div>
                            <div class="col-sm-6" *ngIf="!pdfSrc && !downloadingDocument" style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
                                <div style="width:100%; text-align:center;">
                                    <span>Error Downloading Survey Document</span>
                                </div>
                            </div>
                            <div class="col-sm-6" *ngIf="downloadingDocument" style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
                                <div style="width:100%; text-align:center;">
                                    <span>Downloading Survey Document ...</span>
                                    <i class="fa fa-spinner fa-spin fa-pulse fa-2x"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="detailsPDF" class="tab-pane tab-pane-min-size" [class.in]="currentView === SurveyManagementView.SurveyReport && dataEntryMode === DataEntryMode.Edit" [class.active]="currentView === SurveyManagementView.SurveyReport && dataEntryMode === DataEntryMode.Edit">
                        <div class="row">
                            <div class="col-lg-12">
                                <b>Users Seen:</b> {{ usersSeen }}
                                <br />
                                <b>Users Ignored:</b> {{ usersIgnored }}
                                <br />
                                <b>Users Completed:</b> {{ usersCompleted }}
                                <br />
                                <b>Users Notified:</b> {{ usersNotified }}
                                <br />
                                <b>Users Ignored Forever:</b> {{ usersIgnoredForever }}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12" style="padding: 8px 24px 8px; vertical-align: bottom; text-align: right;">
                                <button type="button" class="btn btn-default" (click)="cancel()">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div bsModal #surveyFilterModal="bs-modal" class="modal fade" [config]="{ keyboard: false, backdrop: 'static' }" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog" style="width:960px;">
        <form (ngSubmit)="applyFilter()">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="closeFilter()">&times;</button>
                    <h4 class="modal-title" id="myModalLabel" style="display:inline-block">
                        <span>Document Management Filter</span>
                    </h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="form-group input-group has-feedback">
                                <label class="control-group input-group-addon" for="filterTitle">Title</label>
                                <input id="filterTitle" name="filterTitle" type="text" class="form-control" placeholder="Title" [(ngModel)]="filterTitle" />
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group input-group has-feedback">
                                <label class="control-group input-group-addon" for="filterProductDescription">Manual Title</label>
                                <input id="filterProductDescription" name="filterProductDescription" type="text" class="form-control" placeholder="Manual Title" [(ngModel)]="filterProductDescription" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="form-group input-group has-feedback">
                                <label class="control-group input-group-addon" for="filterLanguage">Language</label>
                                <select id="filterLanguage" name="filterLanguage" [(ngModel)]="filterLanguage" class="form-control">
                                    <option value="" [selected]="filterLanguage === null">-- Select Language --</option>
                                    <option *ngFor="let language of languages" [value]="language.Value" [selected]="language.Value == filterLanguage">{{ language.Part }}&nbsp;-&nbsp;{{ language.Value }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group input-group has-feedback">
                                <label class="control-group input-group-addon" for="filterCreatedBy">Created By</label>
                                <input id="filterCreatedBy" name="filterCreatedBy" type="text" class="form-control" placeholder="Created By" [(ngModel)]="filterCreatedBy" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="checkbox">
                                <label class="xor-label"><input id="filterAllowIgnore" name="filterAllowIgnore" type="checkbox" [(ngModel)]="filterAllowIgnore">Allow Ignore</label>
                            </div>
                            <div class="checkbox">
                                <label class="xor-label"><input id="filterIsActive" name="filterIsActive" type="checkbox" [(ngModel)]="filterIsActive">Is Active</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-success" *ngIf="filterApplied" (click)="clearFilter()">Clear Filter</button>
                    <button type="submit" class="btn btn-default">Apply Filter</button>
                </div>
            </div>
        </form>
    </div>
</div>

<div bsModal #errModal="bs-modal" class="modal fade" [config]="{ keyboard: false, backdrop: 'static' }" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myModalLabel">
                    {{ errModalTitle }}
                </h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        {{ errModalMsg }}
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-warning" (click)="closeErrModal()">Close</button>
            </div>
        </div>
    </div>
</div>

<div bsModal #deleteConfirmation="bs-modal" class="modal fade" [config]="{ keyboard: false, backdrop: 'static' }" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myModalLabel">
                    Delete Survey Confirmation - {{ deleteConfirmationProductName }}
                </h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <span style="line-height: 1.42857143; font-weight:bold; vertical-align:middle; text-align:center;">
                            Deleting this survey will remove it from view in ProManual and the ProManual administrative site. It will no longer be available.
                        </span>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-warning" (click)="deleteDocument()">Confirm Delete</button>
                <button type="button" class="btn btn-primary" (click)="cancelDeleteConfirmation()">Cancel</button>
            </div>
        </div>
    </div>
</div>

<div bsModal #disableConfirmation="bs-modal" class="modal fade" [config]="{ keyboard: false, backdrop: 'static' }" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myModalLabel">
                    Disable Survey Confirmation - {{ deleteConfirmationProductName }}
                </h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <span style="line-height: 1.42857143; font-weight:bold; vertical-align:middle; text-align:center;">
                            Disabling this survey will prevent it from being displayed to users in ProManual. It will still be available in the ProManual administrative site.
                        </span>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-warning" (click)="disableDocument()">Confirm Disable</button>
                <button type="button" class="btn btn-primary" (click)="cancelDisableConfirmation()">Cancel</button>
            </div>
        </div>
    </div>
</div>

<div bsModal #invalidDate="bs-modal" class="modal fade" [config]="{ keyboard: false, backdrop: 'static' }" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myModalLabel">
                    Proceed with the proposed changes?
                </h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <div *ngFor="let conflict of surveyConflictResolutions;">
                            <p style="font-weight:bold;">
                                    {{ conflict.ConflictDescription }}
                            </p>
                            <p>
                                {{ conflict.ConflictResolutionText }}
                            </p>
                            <br/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="resolveConflicts()">Confirm Changes</button>
                <button type="button" class="btn btn-warning" (click)="cancelInvalidDate()">Cancel</button>
            </div>
        </div>
    </div>
</div>

<div bsModal #surveyConflictModal="bs-modal" class="modal fade" [config]="{ keyboard: false, backdrop: 'static' }" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myModalLabel">
                    Unable to Enable Survey, Conflicts Exist
                </h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <div *ngFor="let conflict of surveyConflictResolutions;">
                            <p style="font-weight:bold;">
                                    {{ conflict.ConflictDescription }}
                            </p>
                            <p>
                                {{ conflict.ConflictResolutionText }}
                            </p>
                            <br/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-warning" (click)="cancelSurveyConflictModal()">Close</button>
            </div>
        </div>
    </div>
</div>